import apolloClient from '@src/graphql/apollo';
import {
  MarkNotificationCenterAsReadDocument,
  NotificationCenterDocument,
  NotificationCenterQuery,
} from '@src/graphql/generated';

export function fetchNotificationCenterApi() {
  return apolloClient.query<NotificationCenterQuery>({
    fetchPolicy: 'no-cache',
    query: NotificationCenterDocument,
  });
}

export function fetchNotificationCenter() {
  return async dispatch => {
    const {
      data: { notificationCenter },
    } = await fetchNotificationCenterApi();

    dispatch(setNotificationCenter(notificationCenter));

    return { notificationCenter };
  };
}

export function markNotificationCenterAsRead(delay) {
  return async dispatch => {
    await markNotificationCenterAsReadApi(delay);
    const { data } = await fetchNotificationCenterApi(delay);
    const { notificationCenter } = data;
    dispatch(setNotificationCenter(notificationCenter));

    return { notificationCenter };
  };
}

export function markNotificationCenterAsReadApi() {
  return apolloClient.mutate({
    fetchPolicy: 'no-cache',
    mutation: MarkNotificationCenterAsReadDocument,
  });
}

export const SET_NOTIFICATION_CENTER = `${__dirname}/setNotificationCenter`;
export function setNotificationCenter(notificationCenter) {
  return { notificationCenter, type: SET_NOTIFICATION_CENTER };
}

export const TOGGLE_NOTIFICATION_CENTER_VISIBILITY = `${__dirname}/toggleNotificationCenterVisibility`;
export function toggleNotificationCenterVisibility() {
  return { type: TOGGLE_NOTIFICATION_CENTER_VISIBILITY };
}
